import React, { PropTypes } from "react";
import CpdLiveItem from "components/CpdLocker/CpdLiveItem";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import moment from "moment";
import storage from "services/storage.js";
import { Link } from "react-router";

const { LIVE_WEBINARS } = constants;

const { loadUsersWebinarsSaga, cleanUsersWebinars, getStudygroups } = actions;

class CpdUserLive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      activeYear: new Date().getFullYear(),
      group_id: "",
    };
  }

  componentWillMount() {
    this.props.loadWebinars(
      this.state.page,
      this.state.activeYear,
      this.state.group_id
    );
    this.props.loadStudygroups({ per_page: 500 });
  }

  nextPage = () => {
    this.setState(
      {
        ...this.state,
        page: this.state.page + 1,
      },
      () => {
        this.props.loadWebinars(
          this.state.page,
          this.state.activeYear,
          this.state.group_id
        );
      }
    );
  };
  onYearClick = (year) => {
    this.setState(
      {
        page: 1,
        activeYear: year,
      },
      () =>
        this.props.loadWebinars(
          this.state.page,
          this.state.activeYear,
          this.state.group_id
        )
    );
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  handleGroupChange = (group_id) => {
    const newYear = new Date().getFullYear();
    const newPage = 1;

    // Always load webinars, regardless of state changes
    this.props.loadWebinars(newPage, newYear, group_id);

    // Update state for UI
    this.setState({
      group_id,
      page: newPage,
      activeYear: newYear,
    });
  };

  render() {
    const token = storage.getSessionData().session.token;
    const { int_cpds, ext_cpds, from, to } = this.props.cpds || {};

    const { studygroups } = this.props;

    const {
      location: { pathname },
    } = this.props;

    const areLiveWebinars = pathname === "/cpd" || pathname.includes("live");
    const areRecordedWebinars = pathname.includes("recorded");

    return (
      <div id="live" className="main_live col s12">
        <div className="cpd-group-filters">
          <button
            className={`button_classic-years ${
              this.state.group_id === "" ? "active" : ""
            }`}
            onClick={() => this.handleGroupChange("")}
          >
            Medcafe
          </button>
          {studygroups.map(({ id, title }) => (
            <button
              key={id}
              onClick={() => this.handleGroupChange(id)}
              className={`button_classic-years ${
                this.state.group_id === id ? "active" : ""
              }`}
            >
              {title}
            </button>
          ))}
        </div>
        <div className="container_tabs">
          <ul className="tabs cpd_tabs">
            <li className="tab col s2">
              <Link className="active" to="/cpd/live">
                Webinars Attended - Live
              </Link>
            </li>
            <li className="tab col s2">
              <Link to="/cpd/recorded">Webinars Viewed - Recorded</Link>
            </li>
          </ul>
        </div>
        <div className="cpd-years">
          {this.props.years.map((year) => (
            <button
              className={`button_classic-years ${
                this.state.activeYear === year ? "active" : ""
              }`}
              onClick={() => this.onYearClick(year)}
            >
              {year}
            </button>
          ))}
        </div>
        <p className="live_total">
          {from &&
            to &&
            `CPD Year: ${moment(from).format("MMMM YY")} – ${moment(to).format(
              "MMMM YY"
            )}`}
          <br />
          {ext_cpds && <span>{`Ext CPD Points Total: ${ext_cpds}`}</span>}
          {ext_cpds && <br />}
          {int_cpds && <span>Int CPD Points Total: {int_cpds}</span>}
        </p>
        <div className="container_recorded">
          {this.props.webinars.map((webinar) => (
            <CpdLiveItem webinar={webinar} token={token} />
          ))}
        </div>
        {this.props.pages > this.state.page && (
          <a
            className="more_item"
            href="javascript:void(0)"
            onClick={this.nextPage}
          >
            LOAD MORE
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  webinars: state.webinars.usersWebinars[LIVE_WEBINARS].values,
  pages: state.webinars.usersWebinars[LIVE_WEBINARS].pages,
  cpds: state.webinars.usersWebinars[LIVE_WEBINARS].cpds,
  years: state.webinars.usersWebinars[LIVE_WEBINARS].years || [],
  studygroups: state.studygroups.studygroups.values,
});

const mapDispatchToProps = (dispatch) => ({
  loadWebinars: (page, year, group_id) =>
    dispatch(loadUsersWebinarsSaga(LIVE_WEBINARS, page, year, group_id)),
  cleanWebinars: () => dispatch(cleanUsersWebinars()),
  loadStudygroups: (page, query) => dispatch(getStudygroups(page, query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdUserLive);



// WEBPACK FOOTER //
// ./src/containers/CpdUser/CpdUserLive.jsx